/** Match statistics flag (`MATCH_STATS_ENABLED`, unset = off; also set it in .env, which the dev server reads at runtime).
 * Delete this module once the stats are on everywhere. */
export const MATCH_STATS_ENABLED = process.env.MATCH_STATS_ENABLED === "true";
